/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IHeiScrollspySectionData } from './hei-scrollspy-section.data';
import { IHeiScrollspySectionProps } from './hei-scrollspy-section.props.autogenerated';

export interface IHeiScrollspySectionViewProps extends IHeiScrollspySectionProps<IHeiScrollspySectionData> {
    hrefAnchor: string;
    titleOnly?: boolean;
}

/**
 *
 * HeiScrollspySection component
 * @extends {React.PureComponent<IHeiScrollspySectionProps<IHeiScrollspySectionData>>}
 */
class HeiScrollspySection extends React.PureComponent<IHeiScrollspySectionProps<IHeiScrollspySectionData>> {
    private readonly hrefAnchor: string;

    public constructor(props: IHeiScrollspySectionProps<IHeiScrollspySectionData>) {
        super(props);
        this.hrefAnchor =
            props.config.hrefAnchor || `scroll-section-${(props.config.sectionTitle ?? '').toLowerCase().replace(/[^\w]/g, '')}`;
    }

    public render(): JSX.Element | null {
        return this.props.renderView({
            ...this.props,
            hrefAnchor: this.hrefAnchor
        });
    }
}

export default HeiScrollspySection;
